package haxe.ui.containers.dialogs;

/**
 Special implementation of `Dialog` to display standard message related dialog boxes on the `Screen`
**/
@:dox(icon = "/icons/application-dialog.png")
class MessageDialog extends Dialog {
    public function new() {
        super();
    }
}